var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Tooltip from "./components/Tooltip";
var ImgReactUITest = /** @class */ (function (_super) {
    __extends(ImgReactUITest, _super);
    function ImgReactUITest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImgReactUITest.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Tooltip, { tooltipText: "huhu du da!", position: "bottom" },
                React.createElement("div", { style: { width: 50, height: 50, backgroundColor: "blue" } }))));
    };
    return ImgReactUITest;
}(React.Component));
export default ImgReactUITest;
//# sourceMappingURL=ImgReactUITest.js.map